import { type FetchResourceParams } from '#api/client'

/** Drops empty values and sorts keys so equivalent params share a query key */
export const sanitizeParams = (
  params: FetchResourceParams,
): FetchResourceParams => {
  const sanitized: FetchResourceParams = {}

  Object.keys(params)
    .sort()
    .forEach(key => {
      const value = params[key]

      if (value === undefined) {
        return
      }

      if (typeof value === 'string' && value.trim().length === 0) {
        return
      }

      if (Array.isArray(value) && value.length === 0) {
        return
      }

      sanitized[key] = Array.isArray(value) ? [...value] : value
    })

  return sanitized
}

/** React Query retry policy: client errors won't succeed on retry, so only retry the rest */
export const retryUnlessClientError = (
  failureCount: number,
  error: Error,
): boolean => {
  const { status } = error as Error & { status?: number }
  if (status !== undefined && status >= 400 && status < 500) {
    return false
  }
  return failureCount < 3
}
